import React, { useState } from "react";
import { PlusIcon } from "@heroicons/react/24/outline";
import { Button } from "../../components/button";
import { PageHeading } from "../../components/pageHeading";
import { Posts } from "../posts";

// Mobile patrol routes: posts that aren't tied to one site. A route's shifts
// visit several sites through their checkpoint and tour activities.
function PatrolRoutes() {
  const [editing, setEditing] = useState(null);

  return (
    <div>
      <main className="py-6">
        <div className="px-4 sm:px-6 lg:px-6">
          <PageHeading title="Patrol routes">
            <Button icon={PlusIcon} onClick={() => setEditing({})}>
              Create patrol route
            </Button>
          </PageHeading>
          <p className="ml-1 mb-4 text-sm text-gray-500 dark:text-gray-400">
            A patrol route covers several sites in one shift. Add the
            checkpoints and tours for each stop to the shift.
          </p>
          <Posts mobile editing={editing} setEditing={setEditing} />
        </div>
      </main>
    </div>
  );
}

export { PatrolRoutes };
